import React, {useContext} from 'react';
import {Button, Descriptions, Space} from 'antd';
import {observer} from "mobx-react";
import {CardStyled} from "../../../components/styled/card.styled";
import {useLoaderData, useNavigate} from "react-router-dom";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {StoreContext} from "../../../store.context";
import AccessUtil from "../../../components/util/access.util";
import {ConfirmButton} from "../../../components/button/confirm.button";
import {UserViewResponse} from "../../../types/modules/user/response";
import {Helmet} from "react-helmet-async";

export const View: React.FC = observer(() => {
    const navigate = useNavigate();
    const data: UserViewResponse = useLoaderData() as UserViewResponse;

    const {
        appStore: {
            moduleStore: {
                userStore: {
                    resetOtp
                }
            }
        }
    } = useContext(StoreContext);

    return (
            <>
            <Helmet>
                <title>{`CL BO - ${data?.username}`}</title>
            </Helmet>
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            <CardStyled title={`View`}>
                <div style={{ padding: '16px', paddingBottom: 0 }}>
                    <Space direction={`vertical`} style={{ display: 'flex' }}>
                        <Descriptions bordered>
                            <Descriptions.Item label={<Translate message={`user.field.username`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.username }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`user.field.firstName`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.firstName }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`user.field.lastName`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.lastName }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`user.field.initials`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.initials }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`user.field.additions`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.additions }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`user.field.email`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.email }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`user.field.disabled`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{  <Translate message={data.disabled?"global.yes":"global.no"}/> }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`user.field.userRoles`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.userRoles?.reduce((a, b) => {
                                return a.length > 1 ? (a + ', ' + b.name) : b.name;
                            }, '') }</Descriptions.Item>
                        </Descriptions>
                    </Space>
                </div>
            </CardStyled>

            <ButtonBar>
                <AccessUtil access={{ routeName: 'user_edit', attributes: [{ id: data.id }]}}>
                    <Space>
                        <Button type={`primary`} onClick={ () => navigate(`/user/${data.id}/edit`)}>
                            <Translate message={`global.button.edit`} />
                        </Button>
                        <Button type="primary" className={`ant-btn-secondary`} onClick={ () => navigate(`/user/${ data.id }/password/edit`) }>
                            <Translate message={`user.button.change_password`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />
                        </Button>
                        <ConfirmButton message={`user.button.reset_otp`} domain={TranslationDomainEnum.USER_ADMINISTRATION} onClick={async () => {
                            await resetOtp({ id: data.id })
                        }} />
                    </Space>
                </AccessUtil>

                <Button type="primary" className={`ant-btn-secondary`} onClick={ () => navigate(`/user`) }>
                    <Translate message={`global.button.back_to_list`} />
                </Button>
            </ButtonBar>
        </Space>
            </>
    )
})